/**
 * 类型转化相关函数
 */

const toBoolean = {
    fn: o => !!o,
    desc: '需要一个参数，将其转换为布尔值',
};

const toOppositeBoolean = {
    fn: o => !o,
    desc: '需要一个参数 a，对其进行非运算 !a',
};

const toNumber = {
    fn: a => {
        const number = a && Number(a);
        // eslint-disable-next-line no-undefined
        return number || number === 0 ? number : undefined;
    },
    desc: '需要一个参数 a，将其转化为Number',
};

const toString = {
    fn: a => `${a}`,
    desc: '需要一个参数 a，将其转化为String',
};

const isInvalid = {
    fn: o => {
        if (!o && o !== 0) {
            return true;
        }
        if (Array.isArray(o) && o.length === 0) {
            return true;
        }
        if (typeof o === 'object' && Object.keys(o).length === 0) {
            return true;
        }
        return false;
    },
    desc: '需要一个参数，判断其值是否为null、undefined、空字符串、空数组、空对象',
};

const isValid = {
    fn: o => !isInvalid.fn(o),
    desc: '需要一个参数，判断其值是否不为null、undefined、空字符串、空数组、空对象',
};

export default {
    toBoolean,
    toOppositeBoolean,
    toNumber,
    toString,
    isInvalid,
    isValid,
};
